import { useEffect, useState } from "react";

/**
 * Loads a side report (customer health, salesman scorecard) once `enabled`.
 * The API layer shares identical requests, so the tabs reuse what this loads.
 * Changing `attempt` asks again (a failed request is never kept).
 */
export default function useSideReport(fetcher, params, enabled, attempt = 0) {
  const signature = enabled ? JSON.stringify([params, attempt]) : null;
  const [state, setState] = useState({ signature: null, data: null, failed: false });
  useEffect(() => {
    if (!signature) return undefined;
    const controller = new AbortController();
    fetcher(JSON.parse(signature)[0], { signal: controller.signal })
      .then((data) => { if (!controller.signal.aborted) setState({ signature, data: data || null, failed: false }); })
      .catch((error) => {
        if (controller.signal.aborted || error?.code === "ERR_CANCELED") return;
        setState({ signature, data: null, failed: true });
      });
    return () => controller.abort();
  }, [fetcher, signature]);
  const ready = signature != null && state.signature === signature;
  return { data: ready ? state.data : null, loading: signature != null && !ready, failed: ready && state.failed };
}
